/* istanbul ignore file */
export const PdfsPrestations = [
  {
    policyNumber: '2000GRP0001380',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/2000GRP0001380.pdf',
  },
  {
    policyNumber: '2000GRP0001387',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/2000GRP0001387.pdf',
  },
  {
    policyNumber: '2000GRP0001654',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/2000GRP0001654.pdf',
  },
  {
    policyNumber: '2000GRP0001669',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/2000GRP0001669.pdf',
  },
  {
    policyNumber: '2000GRP1621001',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/2000GRP1621001.pdf',
  },
  {
    policyNumber: '2000GRP1621003',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/2000GRP1621003.pdf',
  },
  {
    policyNumber: '2000GRP1621004',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/2000GRP1621004.pdf',
  },
  {
    policyNumber: '2000GRP1664001',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/2000GRP1664001.pdf',
  },
  {
    policyNumber: '0600993442',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600993442.pdf',
  },
  {
    policyNumber: '0600995472',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600995472.pdf',
  },
  {
    policyNumber: '0600995985',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600995985.pdf',
  },
  {
    policyNumber: '0600996076',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996076.pdf',
  },
  {
    policyNumber: '0600996135',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996135.pdf',
  },
  {
    policyNumber: '0600996475',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996475.pdf',
  },
  {
    policyNumber: '0600996476',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996476.pdf',
  },
  {
    policyNumber: '0600996481',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996481.pdf',
  },
  {
    policyNumber: '0600996720',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996720.pdf',
  },
  {
    policyNumber: '0600996750',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996750.pdf',
  },
  {
    policyNumber: '0600996854',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996854.pdf',
  },
  {
    policyNumber: '0600996854/01',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996854_01.pdf',
  },
  {
    policyNumber: '0600996895',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600996895.pdf',
  },
  {
    policyNumber: '0600999446',
    pdfUri:
      'https://mobile-prestation-amc.s3.eu-central-1.amazonaws.com/0600999446.pdf',
  },
];
